import { createRouter, createWebHistory } from 'vue-router'
import HomeView from "@/views/HomeView.vue";
import CheckInventoryView from "@/views/CheckInventoryView.vue";
import { isOnline } from '@/services/healthCheck';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    { path: '/', name: 'home', component: HomeView},
    { path: '/checkinventory', name: 'checkinventory', component: CheckInventoryView },
    // Shareable search links: /itemsearch?q=<term> → the Check Inventory tool with the
    // term auto-searched (after its inline login, if needed). Query string is forwarded.
    { path: '/itemsearch', redirect: to => ({ path: '/checkinventory', query: to.query }) },
  ]
})

// Check Inventory is an online-only tool — it must not work at all offline. The service
// worker also excludes /checkinventory from the offline shell (vite.config
// navigateFallbackDenylist), so a direct load/refresh offline won't even load; this guard
// covers in-app (client-side) navigation while offline.
router.beforeEach((to, _from, next) => {
  if (to.path.startsWith('/checkinventory') && (!isOnline.value || !navigator.onLine)) {
    return next({ path: '/' });
  }
  next();
});

export default router
